import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import PlusIcon from "@material-ui/icons/Add";
import TablePagination from "@material-ui/core/TablePagination";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

const headRows = [
  {
    id: "structureName",
    numeric: false,
    disablePadding: false,
    label: "Struktur adı",
  },
  {
    id: "source",
    numeric: false,
    disablePadding: false,
    label: "Mənbə",
  },


  {
    id: "tools",
    numeric: false,
    disablePadding: false,
    label: "Əməliyyatlar",
  }
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,

  } = props;

  return (
    <TableHead>
      <TableRow>

        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return  row.id !== "source" && row.id !== "tools" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
};


const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));


const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    setShowCreate,
    permissionList
  } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >

      <div className={classes.actions}>
      { permissionList.some(element => element === "create_structure_device_place") && 

        <Tooltip title="Əlavə et" placement="top">
          <button
            className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
            onClick={() => setShowCreate(true)}
          >
            <PlusIcon />
          </button>
        </Tooltip>}
      </div>
    </Toolbar>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  logRows,
  isLoading,
  isError,
  setLogId,
  setShowCreate,
  setShowRemove,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  skip,
  take,
  filterInputsUpdate,
  filterInputs,
  count,
  searchField,
  logRows1

}) {

  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  function handleRequestSort(property) {
    // const isDesc = sortField === property && !orderBy;
    const isDesc = sortField === property && orderBy === 'desc';


    // setOrderByTable(isDesc);
    setOrderByTable(isDesc ? 'asc' : 'desc');

    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const permissionList= useSelector(state => state.auth.permissionList)

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          setShowCreate={setShowCreate}
          filterInputsUpdate={filterInputsUpdate}
          filterInputs={filterInputs}
          permissionList={permissionList}
        />


        <div className={classes.tableWrapper}>
          { logRows.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                rowCount={logRows.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}

              />
              <TableBody>
                {searchField.trim() == "" ?
                  logRows.map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow hover tabIndex={-1} key={row.id}>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.structureName ? row.structureName : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.source ? row.source : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                       { permissionList.some(element => element === "delete_structure_device_place") && 

                        <Tooltip title="Sil" placement="top">
                          <button
                            aria-label="delete"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger mr-2"
                            onClick={(e) => {
                              setLogId(row.id);
                              setShowRemove(true);
                            }}
                          >
                          <DeleteIcon />
                          </button>
                        </Tooltip>}
                        
                      </TableCell>
                       
                      </TableRow>
                    );
                  })

                  :
                  logRows1.map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow hover tabIndex={-1} key={row.id}>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.structureName ? row.structureName : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.source ? row.source : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                       { permissionList.some(element => element === "delete_structure_device_place") && 

                        <Tooltip title="Sil" placement="top">
                          <button
                            aria-label="delete"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger mr-2"
                            onClick={(e) => {
                              setLogId(row.id);
                              setShowRemove(true);
                            }}
                          >
                          <DeleteIcon />
                          </button>
                        </Tooltip>}
                        
                      </TableCell>
                       
                      </TableRow>
                    );
                  })
                
                }
              </TableBody>
            </Table>
          ) : !logRows.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>
        {count > 10 && (
          <TablePagination
            rowsPerPageOptions={[100, 120, 150]}
            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  );
}
